import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import SearchModuleForHighVolume from './SearchModuleForHighVolume'
import COLOR_LIST from '../../constants/taskColor'

interface MasterRelationLabelGroup {
  callbackIds: (ids: number[]) => void
  list: { id: number, name: string }[]
  disableState: boolean
  callbackDisable: (changed: boolean) => void
}

interface Props {
  name: string
  callbackLabelMasterKeywords?: (labelMasterKeywords: string[]) => void
  callbackTeamIds?: (teamIds: number[]) => void
  callbackMemberIds?: (memberIds: number[]) => void
  callbackLabelGroupIds?: (projectIds: number[]) => void
  callbackColors?: (colors: string[]) => void
  labelMasterKeywords?: string[]
  memberList?: { id: number, name: string }[]
  teamList?: { id: number, name: string }[]
  labelGroupList?: { id: number, name: string }[]
  colors?: string[]
  masterRelationLabelGroup?: MasterRelationLabelGroup
}

const SearchConditionModuleForHighVolume: FC<Props> = (props) => {
  const {
    name,
    callbackLabelMasterKeywords,
    callbackTeamIds,
    callbackMemberIds,
    callbackLabelGroupIds,
    callbackColors,
    labelMasterKeywords,
    memberList,
    teamList,
    labelGroupList,
    colors,
    masterRelationLabelGroup,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const [isDisplaySticky, setIsDisplaySticky] = useState<boolean>(false)

  const scrollTop = (): number => Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)

  const onScroll = (): void => {
    if (scrollTop() <= 400) {
      setIsDisplaySticky(false)
    } else {
      setIsDisplaySticky(true)
    }
  }

  const body = (type?: string) => (
    <>
      <div className="search_condition_title">
        絞り込み条件
        {
          type ? (
            <></>
          ) : (
            <SearchModuleForHighVolume
              callbackLabelMasterKeywords={callbackLabelMasterKeywords}
              callbackMemberIds={callbackMemberIds}
              callbackTeamIds={callbackTeamIds}
              callbackLabelGroupIds={callbackLabelGroupIds}
              callbackColors={callbackColors}
              labelMasterKeywords={labelMasterKeywords}
              memberList={memberList}
              teamList={teamList}
              labelGroupList={labelGroupList}
              colors={colors}
              masterRelationLabelGroup={masterRelationLabelGroup}
            />
          )
        }
      </div>
      <div className="chip_wrap">
        {
          labelMasterKeywords && labelMasterKeywords.length ? (
            <div className="chip_area">
              <div>
                業務名：
              </div>
              <div className="chip_list">
                <div className="chip">
                  {`「${labelMasterKeywords.join(",")}」を含む業務名`}
                </div>
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          teamList?.length ? (
            <div className="chip_area">
              <div>
                チーム：
              </div>
              <div className="chip_list">
                {
                  teamList?.map((team) => (
                    <div
                      key={`search_condition_team_${team.id}`}
                      className="chip"
                    >
                      {team.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          memberList?.length ? (
            <div className="chip_area">
              <div>
                メンバー：
              </div>
              <div className="chip_list">
                {
                  memberList.map((member) => (
                    <div
                      key={`search_condition_member_${member.id}`}
                      className="chip"
                    >
                      {member.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          labelGroupList?.length ? (
            <div className="chip_area">
              <div>
                プロジェクト：
              </div>
              <div className="chip_list">
                {
                  labelGroupList.map((labelGroup) => (
                    <div
                      key={`search_condition_project_${labelGroup.id}`}
                      className="chip"
                    >
                      {labelGroup.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          masterRelationLabelGroup?.list.length && !masterRelationLabelGroup.disableState ? (
            <div className="chip_area">
              <div>
                プロジェクト：
              </div>
              <div className="chip_list">
                {
                  masterRelationLabelGroup.list.map((labelGroup) => (
                    <div
                      key={`search_condition_project_${labelGroup.id}`}
                      className="chip"
                    >
                      {labelGroup.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          masterRelationLabelGroup?.disableState ? (
            <div className="chip_area">
              <div>
                プロジェクト：プロジェクトに紐づいていない業務のみ表示
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          colors?.length ? (
            <div className="chip_area">
              <div>
                プロジェクトカラー：
              </div>
              <div className="chip_list">
                {
                  COLOR_LIST.map((v) => v.values).flat().filter((v) => colors.includes(v.label)).map((color) => (
                    <div
                      key={`search_condition_color_${color.label}`}
                      className="chip"
                    >
                      <div
                        style={{
                          backgroundColor: color.color,
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                        }}
                      />
                      {color.text}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          !labelMasterKeywords?.length
          && !teamList?.length
          && !memberList?.length
          && !labelGroupList?.length
          && !masterRelationLabelGroup?.list.length
          && !masterRelationLabelGroup?.disableState
          && !colors?.length
          && (
            <>
              絞り込み条件は指定されていません
            </>
          )
        }
      </div>
    </>
  )

  useEffect(() => {
    if (!login.accessToken) return
    document.addEventListener("scroll", onScroll)
    // eslint-disable-next-line no-unused-expressions
    document.querySelector('html')?.classList.add('scroll_contents')
  }, [login.accessToken])

  return (
    <>
      <section className={`sticky_header ${isDisplaySticky && "active"}`}>
        <div style={{ width: "100%" }}>
          <div className="sticky_header_title">
            {name}
          </div>
          {body("head")}
        </div>
      </section>
      <section className="search_condition">
        {body()}
      </section>
    </>
  )
}

SearchConditionModuleForHighVolume.defaultProps = {
  callbackLabelMasterKeywords: undefined,
  callbackTeamIds: undefined,
  callbackMemberIds: undefined,
  callbackLabelGroupIds: undefined,
  callbackColors: undefined,
  labelMasterKeywords: undefined,
  memberList: undefined,
  teamList: undefined,
  labelGroupList: undefined,
  colors: undefined,
  masterRelationLabelGroup: undefined,
}

export default SearchConditionModuleForHighVolume
